up.compiler('[content-code-search]', (element) => {
  document.body.classList.add('-search-shown')

  return () => {
    document.body.classList.remove('-search-shown')
  }
})
